// Insight content aggregator. Each slug is imported from its own file for
// maintainability — the source books are long-form.
import insightToImpact from './insights/insight-to-impact';
import genaiValueBlueprint from './insights/genai-value-blueprint';
import composableCommerceHandbook from './insights/composable-commerce-handbook';
import rethinkingContentCommerce from './insights/rethinking-content-commerce';
import futureOfRetail from './insights/future-of-retail';

export const CONTENT = {
  'insight-to-impact': insightToImpact,
  'genai-value-blueprint': genaiValueBlueprint,
  'composable-commerce-handbook': composableCommerceHandbook,
  'rethinking-content-commerce': rethinkingContentCommerce,
  'future-of-retail': futureOfRetail,
};
